import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Image from "next/image";
import RichTextField from "../RichTextField";

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => theme.mq.md`
    height: 32.1875rem;
    flex-direction: row;
  `};
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 23.125rem;
  max-height: 100%;
  flex: 1 0 auto;
  ${({ theme }) => theme.mq.md`
    max-width: 50%;
    height: auto;
    max-height: 100%;
  `};
`;

const StyledImage = styled(Image)``;

const TextWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 50%;
  background-color: ${({ theme }) => theme.themeColors.lightGreen4};
  ${({ theme }) => theme.mq.md`
    width: 50%;
    height: auto;
    justify-content: center;
  `};
`;

const Title = styled.div`
  font-size: ${({ theme }) => theme.fontSize(5)};
  font-weight: 600;
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  margin: 4.0625rem 1.5rem 1.5rem 1.5rem;
  max-width: 23.75rem;
  line-height: 1.2;
  ${({ theme }) => theme.mq.md`
    margin: 1.5rem;
  `};
`;

const RichTextWrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSize(2)};
  font-weight: 400;
  margin: 0 1.5rem 4.0625rem 1.5rem;
  max-width: 24.5rem;
  ${({ theme }) => theme.mq.md`
    margin: 0 1.5rem 1.5rem;
  `};
`;

const LocationPageImageTextBlock = ({ blockData }) => {
  return (
    <OuterWrapper>
      <ImageWrapper>
        {blockData?.image && (
          <StyledImage
            alt="man grooming dog"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            priority
            src={`https:${blockData?.image?.fields?.file?.url}`}
          />
        )}
      </ImageWrapper>
      <TextWrapper>
        <Title>{blockData.title}</Title>
        <RichTextWrapper>
          <RichTextField richText={blockData.subtitle} textAlignment="center" />
        </RichTextWrapper>
      </TextWrapper>
    </OuterWrapper>
  );
};

export default LocationPageImageTextBlock;

LocationPageImageTextBlock.propTypes = {
  blockData: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    image: PropTypes.shape({
      fields: PropTypes.shape({
        title: PropTypes.string,
        file: PropTypes.shape({
          fileName: PropTypes.string,
          contentType: PropTypes.string,
          url: PropTypes.string,
          details: PropTypes.shape({
            image: PropTypes.shape({
              height: PropTypes.number,
              width: PropTypes.number,
            }),
          }),
        }),
      }),

      sys: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }),
};

LocationPageImageTextBlock.defaultProps = {
  blockData: undefined,
};
